/**
 * Hydrates same-brand PDP rail — merges brand collections + full catalog by vendor.
 */
(function () {
  var JSON_LIMIT = 250;

  function shopBaseUrl() {
    var r =
      (typeof window !== 'undefined' && window.routes && window.routes.root_url) ||
      (typeof window !== 'undefined' &&
        window.Shopify &&
        window.Shopify.routes &&
        window.Shopify.routes.root) ||
      '';
    r = String(r || '').trim();
    if (!r) {
      return typeof window !== 'undefined' ? window.location.origin + '/' : '/';
    }
    return r.endsWith('/') ? r : r + '/';
  }

  function collectionProductsJsonUrl(handle, page) {
    var path =
      'collections/' +
      encodeURIComponent(handle) +
      '/products.json?limit=' +
      JSON_LIMIT +
      '&page=' +
      page;
    var base = shopBaseUrl();
    try {
      return new URL(path, base).href;
    } catch (_e) {
      return path.indexOf('/') === 0 ? path : '/' + path;
    }
  }

  function fetchAllProducts(handle) {
    var all = [];
    var page = 1;

    function next() {
      return fetch(collectionProductsJsonUrl(handle, page))
        .then(function (r) {
          if (!r.ok) throw new Error('products.json ' + r.status);
          return r.json();
        })
        .then(function (data) {
          var batch = data.products || [];
          for (var i = 0; i < batch.length; i++) all.push(batch[i]);
          if (batch.length < JSON_LIMIT) return all;
          page += 1;
          return next();
        });
    }

    return next();
  }

  function vendorKey(p) {
    return String((p && p.vendor) || '')
      .toLowerCase()
      .trim();
  }

  function mergeHandles(products, opts) {
    var handles = opts.handles.slice();
    var seenHandle = Object.create(null);
    var i;
    for (i = 0; i < handles.length; i++) seenHandle[handles[i]] = true;

    for (i = 0; i < products.length && handles.length < opts.limit; i++) {
      var p = products[i];
      if (!p || !p.id || !p.handle) continue;
      if (opts.productId && p.id === opts.productId) continue;
      if (vendorKey(p) !== opts.vendorKey) continue;
      if (seenHandle[p.handle]) continue;
      seenHandle[p.handle] = true;
      handles.push(p.handle);
    }
    return handles;
  }

  function collectionHandlesToTry(root) {
    var list = [];
    var seen = Object.create(null);
    function add(h) {
      h = String(h || '').trim();
      if (!h || seen[h]) return;
      seen[h] = true;
      list.push(h);
    }
    add(root.dataset.brandHandle);
    add(root.dataset.vendorHandle);
    var vh = root.dataset.vendorHandle;
    if (vh) {
      add(vh + '-1');
      add(vh + '-2');
      add(vh + '-3');
    }
    add('all');
    return list;
  }

  function wakeSlider(root) {
    var sliderComponent = root.querySelector('slider-component');
    if (!sliderComponent) return;
    if (typeof sliderComponent.syncScrollPort === 'function') {
      sliderComponent.syncScrollPort();
    }
    if (typeof sliderComponent.initPages === 'function') {
      sliderComponent.initPages();
    }
    if (typeof sliderComponent.update === 'function') {
      sliderComponent.update();
    }
  }

  function hydrate(root, handles) {
    if (!handles.length) return Promise.resolve();
    var sectionId = root.dataset.sectionId;
    var params = new URLSearchParams();
    params.set('section_id', sectionId);
    params.set('skipp_same_brand_handles', handles.join(','));
    var url = window.location.pathname + '?' + params.toString();
    return fetch(url)
      .then(function (r) {
        return r.ok ? r.text() : '';
      })
      .then(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-skipp-same-brand]');
        if (!fresh) return;
        var slider = fresh.querySelector('[data-skipp-pdp-rail-slider]');
        if (!slider) return;
        var existing = root.querySelector('[data-skipp-pdp-rail-slider]');
        if (existing) {
          existing.replaceWith(slider);
        } else {
          root.appendChild(slider);
        }
        root.dataset.skippSameBrandReady = '1';
        wakeSlider(root);
        document.dispatchEvent(new CustomEvent('skipp:collection-delivery-split'));
      });
  }

  function init(root) {
    if (!root || root.dataset.skippSameBrandReady === '1') return;

    var vendorKeyTarget = String(root.dataset.productVendor || '')
      .toLowerCase()
      .trim();
    var productId = parseInt(root.dataset.productId, 10);
    var sectionId = root.dataset.sectionId;
    var limit = parseInt(root.dataset.limit, 10) || 10;
    var cardCount = root.querySelectorAll('.product-grid .grid__item').length;

    if (!sectionId || !vendorKeyTarget) return;

    if (cardCount >= limit) {
      root.dataset.skippSameBrandReady = '1';
      wakeSlider(root);
      return;
    }

    var handles = [];
    var domItems = root.querySelectorAll('.product-grid .grid__item');
    for (var d = 0; d < domItems.length; d++) {
      var link = domItems[d].querySelector('a[href*="/products/"]');
      if (!link) continue;
      var match = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
      if (match && match[1]) handles.push(match[1]);
    }

    var tries = collectionHandlesToTry(root);
    var chain = Promise.resolve(handles);

    tries.forEach(function (collHandle) {
      chain = chain.then(function (acc) {
        if (acc.length >= limit) return acc;
        return fetchAllProducts(collHandle).then(function (products) {
          return mergeHandles(products, {
            handles: acc,
            limit: limit,
            vendorKey: vendorKeyTarget,
            productId: productId,
          });
        });
      });
    });

    chain
      .then(function (finalHandles) {
        if (finalHandles.length > cardCount) {
          return hydrate(root, finalHandles);
        }
        if (cardCount > 0) {
          root.dataset.skippSameBrandReady = '1';
          wakeSlider(root);
        }
      })
      .catch(function () {
        if (cardCount > 0) {
          wakeSlider(root);
        }
      });
  }

  function boot() {
    document.querySelectorAll('[data-skipp-same-brand]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
